import {dogStatusFilters, sexChoices} from '@/lib/choices';
import {formatOwnerDogCounts} from '@/utils/formatOwnerDogCounts';
import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    List,
    ReferenceField,
    SelectInput,
    TextField,
    SearchInput
} from 'react-admin';

const filters = [
    <SearchInput
        key="search"
        source="q"
        alwaysOn
        placeholder="Dog or owner name"
        size="small"
    />,
    <SelectInput
        key="sex"
        source="sex"
        label="Sex"
        emptyText="All"
        choices={sexChoices}
        alwaysOn
        size="small"
    />,
    <SelectInput
        key="status"
        source="status"
        label="Status"
        emptyText="All"
        choices={dogStatusFilters}
        alwaysOn
        size="small"
    />,
];

export const DogList = () => (
    <List filters={filters} perPage={25}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="name" sortable={false} />
            <TextField source="sex" sortable={false} />
            <ReferenceField
                source="user_id"
                reference="users"
                label="Owner"
                sortable={true}
            >
                <FunctionField
                    render={(user) => `${user.first_name} ${user.last_name}`}
                />
            </ReferenceField>
            <ReferenceField
                source="user_id"
                reference="users"
                label="Location"
                sortable={false}
            >
                <FunctionField
                    render={(user) =>
                        `${user.location.suburb}, ${user.location.state}`
                    }
                />
            </ReferenceField>
            <ReferenceField
                source="user_id"
                reference="users"
                label="Breeder"
                sortable={false}
            >
                <BooleanField source="is_registered_breeder" />
            </ReferenceField>
            <ReferenceField
                source="user_id"
                reference="users"
                label="Dogs"
                sortable={false}
            >
                <FunctionField render={(user) => formatOwnerDogCounts(user)} />
            </ReferenceField>
            <TextField source="status" sortable={false} />
            <DateField
                source="updated_at"
                label="Last update"
                sortable={false}
            />
        </Datagrid>
    </List>
);
